// extracted by mini-css-extract-plugin
export default {"revisions":"EntityDetailsHeader_revisions__aPey0","save":"EntityDetailsHeader_save__RLqqL"};